"use client"
import {
  Container,
  ContainerProps,
  Paper,
  PaperProps,
  Stack,
  StackProps,
} from "@mui/material"
import { toPageAttributes } from "@tc/ui-dfe/utils/convertor"
import useCloudWatch from "@tc/ui-rum/hooks/useCloudWatch"
import { useParams, usePathname } from "next/navigation"
import { useEffect } from "react"
import { PageFooter } from "./PageFooter"
import { FEATURE_FLAGS } from "@tc/ui-permission/utils"
import { Permission } from "@tc/ui-permission/components"
export interface PageProps extends PaperProps {
  children?: React.ReactNode
  ContainerProps?: ContainerProps & StackProps
  spacing?: number
  fluid?: boolean
  flags?: FEATURE_FLAGS[]
}

export const Page = (props: PageProps) => {
  const {
    children,
    ContainerProps,
    spacing = 2.5, //default spacing
    sx,
    fluid,
    flags,
    ...paperProps
  } = props
  const { recordPageView } = useCloudWatch()
  const pathname = usePathname()
  const params = useParams()
  useEffect(() => {
    const pageId = toPageAttributes(pathname, params)
    recordPageView({ pageId })
  }, [])
  return (
    <Permission allow={[...(flags || [])]}>
      <Paper
        data-testid="appPage"
        id="appPage"
        elevation={0}
        square
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          bgcolor: "background.default",
          ...sx,
        }}
        {...paperProps}
      >
        <Container
          id="page-container"
          component={Stack}
          maxWidth={fluid ? false : "xl"}
          disableGutters
          spacing={spacing}
          {...ContainerProps}
          sx={{
            m: "auto",
            px: 0,
            py: 3,
            display: "flex",
            flexGrow: 1,
            ...ContainerProps?.sx,
          }}
        >
          {children}
        </Container>
      </Paper>
      <PageFooter />
    </Permission>
  )
}
